import React from "react";
import about from "./about.module.css";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";

const Connecting = () => {
    return (
        <div className={about.connecting_container}>
            <div className={about.connect1}>
                <p id={about.connectheader}>Need any Help?</p>
                <h2 className={about.connecttext}>
                    Connect with Our Team for Assistance
                </h2>
                <button type="button" className={about.connectbtn}>
                    Our Team
                </button>
            </div>
            <div className={about.connect2}>
                <div className={about.connectbox}>
                    <div className={about.connectimage_container}>
                        <FaPhone className={about.connectbox_icon} />
                    </div>
                    <div className={about.connect_info}>
                        <p id={about.calltext}>Call us 24/7</p>
                        <p id={about.callno}>040-35511840</p>
                    </div>
                </div>
                <div className={about.connectbox}>
                    <div className={about.connectimage_container}>
                        <MdEmail className={about.connectbox_icon} />
                    </div>
                    <div className={about.connect_info}>
                        <p id={about.calltext}>Mail us anytime</p>
                        <p id={about.callno}>info@kohere.in</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connecting;
